/* global Confluence */

import window from 'window-or-global';
import { WRM } from '@confluence-classic/confluence-wrm';

export const openCreateSpaceDialog = function openCreateSpaceDialog() {
	WRM.require([
		'wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:resources',
	]).then(() => {
		window.Confluence.SpaceBlueprint.Dialog.launch();
	});
};

export const openCreatePageDialog = function openCreatePageDialog() {
	WRM.require([
		'wr!com.atlassian.confluence.plugins.confluence-create-content-plugin:resources',
	]).then(() => {
		window.Confluence.Blueprint.loadDialogAndOpenTemplate({});
	});
};

export const getLink = function getLink() {
	return Confluence.Link;
};

export default typeof Confluence !== 'undefined' ? Confluence : {};

export const rebindUserHover = () =>
	typeof Confluence !== 'undefined' &&
	Confluence.Binder &&
	Confluence.Binder.userHover &&
	Confluence.Binder.userHover();
